
<div class='container'>

<data-table
[title]='titleIncapacidades'
[columns]='columnasIncapacidades'
[configuration]='configurationIncapacidades'
[reloadTable]='recargarTablaIncapacidades'
(add)='agregarIncapacidades($event)'
(edit)='editarIncapacidades($event)'
(delete)='eliminarIncapacidades($event)'
(selection)='seleccionadosIncapacidades($event)'
(view)='viewDisabilitie($event)'
[params]='[]'
[url]='urlGetIncapacidades'
></data-table>


</div>
